/**
 * Whether an account has signed up but not yet been given anything to do.
 *
 * `/auth/register` assigns the role `member`, which grants only "read your own
 * notifications" — deliberately, because registration is anonymous and the
 * `employee` set would hand an unknown caller `read Employee`, `read Payroll`
 * and `read Compensation` for the whole tenant.
 *
 * The consequence is a real account that can do nothing until an
 * administrator assigns a role. Before this existed, such a person landed on
 * the HR dashboard and watched every widget answer 403 — which reads as a
 * broken product rather than a pending one.
 */

/** The role `/auth/register` assigns. Not in ASSIGNABLE_ROLES — it is never granted by hand. */
const PENDING_ROLE = 'member';

export function isAwaitingAccess(roles: readonly string[]): boolean {
  if (roles.length === 0) return true;

  // `member` alongside a real role means someone has since been granted
  // access; the leftover `member` must not drag them back to the waiting
  // screen.
  return roles.every((role) => role === PENDING_ROLE);
}
